import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context';
import { Error404 } from '../ErrorPages';
import { CreateDevice, Device, Devices, EditDevice } from './pages';

export const DevicesEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Devices',
      element: <Devices />,
      path: '/',
    },
    {
      label: 'Details',
      element: <Device />,
      path: '/:id',
    },
    {
      label: 'Edit Device',
      element: <EditDevice />,
      path: '/:id/edit',
    },
    {
      label: 'New',
      element: <CreateDevice />,
      path: '/new',
      parentPath: '/devices',
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return (
    <Fragment key="routes">{routes}</Fragment>
  );
};
